// import { useEffect, useRef } from 'react';
// import { v4 as uuidv4 } from 'uuid';
// import { useSelector } from 'react-redux';

// const ACTIVITY_INTERVAL = 1 * 60 * 1000; // 2 minutes
// const INACTIVITY_INTERVAL = 1 * 60 * 1000; // 1 minute
// const INACTIVITY_LIMIT = 60; // 10 minutes

// function getSessions() {
//   const sessions = localStorage.getItem('userSessions');
//   return sessions ? JSON.parse(sessions) : [];
// }

// function saveSessions(sessions) {
//   localStorage.setItem('userSessions', JSON.stringify(sessions));
// }

// function getCurrentSession() {
//   const session = localStorage.getItem('currentUserSession');
//   return session ? JSON.parse(session) : null;
// }

// function saveCurrentSession(session) {
//   localStorage.setItem('currentUserSession', JSON.stringify(session));
// }

// function removeCurrentSession() {
//   localStorage.removeItem('currentUserSession');
// }

// function showInactivityMessage() {
//   // Stocker la raison de déconnexion pour l'afficher sur la page de connexion
//   localStorage.setItem('disconnectionReason', 'inactivity');

//   // Afficher une alerte immédiate
//   alert("Vous avez été déconnecté car vous étiez inactif pendant plus de 10 minutes.");
// }

// export default function useSessionTracker(isLoggedIn, onSessionEnd) {
//   const userEmail = useSelector(state => state.user?.user?.email);
//   const activityTimeout = useRef(null);
//   const activityInterval = useRef(null);
//   const inactivityInterval = useRef(null);
//   const lastActivity = useRef(Date.now());
//   const isTabActive = useRef(true);

//   // Crée une session uniquement au login
//   useEffect(() => {
//     if (isLoggedIn && userEmail) {
//       let session = getCurrentSession();
//       if (!session || session.userId !== userEmail || session.endedAt) {
//         // Pas de session courante valide, on en crée une nouvelle
//         session = {
//           sessionId: uuidv4(),
//           userId: userEmail,
//           startedAt: new Date().toISOString(),
//           endedAt: '',
//           activity_duration: 0,
//           inactivity_duration: 0
//         };
//         saveCurrentSession(session);
//       }
//       setupActivityListeners();
//       startActivityTimer();
//       startInactivityTimer();
//     }
//     return () => {
//       cleanupActivityListeners();
//       clearInterval(activityInterval.current);
//       clearInterval(inactivityInterval.current);
//       clearTimeout(activityTimeout.current);
//     };
//     // eslint-disable-next-line
//   }, [isLoggedIn, userEmail]);

//   // Incrémente la durée d'activité toutes les 2 min si actif
//   function startActivityTimer() {
//     clearInterval(activityInterval.current);
//     activityInterval.current = setInterval(() => {
//       const session = getCurrentSession();
//       if (session && isTabActive.current && Date.now() - lastActivity.current < INACTIVITY_INTERVAL) {
//         session.activity_duration += 1;
//         console.log("Activité (minutes) :", session.activity_duration);
//         saveCurrentSession(session);
//       }
//     }, ACTIVITY_INTERVAL);
//   }

//   // Incrémente la durée d'inactivité toutes les 1 min si inactif ou onglet caché
//   function startInactivityTimer() {
//     clearInterval(inactivityInterval.current);
//     inactivityInterval.current = setInterval(() => {
//       const session = getCurrentSession();
//       if (session && (!isTabActive.current || Date.now() - lastActivity.current >= INACTIVITY_INTERVAL)) {
//         session.inactivity_duration += 1;
//         console.log("Inactivité (minutes) :", session.inactivity_duration);
//         saveCurrentSession(session);
//         if (session.inactivity_duration >= INACTIVITY_LIMIT) {
//           endSession();
//         }
//       }
//     }, INACTIVITY_INTERVAL);
//   }

//   // Fin de session (inactivité ou logout)
//   function endSession() {
//     const session = getCurrentSession();
//     if (session && !session.endedAt) {
//       session.endedAt = new Date().toISOString();
//       const sessions = getSessions();
//       sessions.push(session);
//       saveSessions(sessions);
//       removeCurrentSession();

//       // Affiche le message de déconnexion pour inactivité
//       showInactivityMessage();

//       if (typeof onSessionEnd === "function") {
//       onSessionEnd(); // <-- call the logout callback
//     }
//     }
//   }

//   // Réinitialise le timer d'inactivité à chaque activité
//   function activityHandler(event) {
//   lastActivity.current = Date.now();
//   // Reset inactivity_duration à chaque activité
//   const session = getCurrentSession();
//   if (session && session.inactivity_duration !== 0) {
//     session.inactivity_duration = 0;
//     saveCurrentSession(session);
//   }
//   console.log('[SessionTracker] Activity detected:', event ? event.type : 'unknown');
//     // Si l'utilisateur redevient actif, on peut reset inactivity_duration si besoin
//   }

//   // Gestion de la visibilité de l'onglet
//   function handleVisibilityChange() {
//     isTabActive.current = !document.hidden;
//     if (!document.hidden) {
//       lastActivity.current = Date.now();
//     }
//   }

//   function setupActivityListeners() {
//     const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click', 'popstate'];
//     // Pour navigation SPA (pushState/replaceState)
//     const wrapHistoryEvent = (type) => {
//       const orig = window.history[type];
//       return function() {
//         const rv = orig.apply(this, arguments);
//         window.dispatchEvent(new Event(type));
//         return rv;
//       };
//     };
//     window.history.pushState = wrapHistoryEvent('pushState');
//     window.history.replaceState = wrapHistoryEvent('replaceState');

//     // Ajout listeners sur window ET document pour click/scroll
//     events.forEach(event => {
//       window.addEventListener(event, activityHandler, true);
//       if (event === 'click' || event === 'scroll') {
//         document.addEventListener(event, activityHandler, true);
//       }
//     });
//     window.addEventListener('pushState', activityHandler, true);
//     window.addEventListener('replaceState', activityHandler, true);
//     document.addEventListener('visibilitychange', handleVisibilityChange);
//   }

//   function cleanupActivityListeners() {
//     const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click', 'popstate'];
//     events.forEach(event => {
//       window.removeEventListener(event, activityHandler, true);
//       if (event === 'click' || event === 'scroll') {
//         document.removeEventListener(event, activityHandler, true);
//       }
//     });
//     window.removeEventListener('pushState', activityHandler, true);
//     window.removeEventListener('replaceState', activityHandler, true);
//     document.removeEventListener('visibilitychange', handleVisibilityChange);
//   }

//   return { endSession };
// }

import { useEffect, useRef } from "react";

import { useSelector } from "react-redux";
import {
  createNewSession,
  addHeartbeat,
  checkSessionTimeout,
  endCurrentSession,
  fixOrphanedSessions,
  HEARTBEAT_INTERVAL, // Import de la constante partagée
  getCurrentSession, // Import de la fonction utilitaire
  saveCurrentSession, // Import de la fonction utilitaire
} from "./sessionUtils";
import {
  autosaveCurrentSession,
  AUTOSAVE_INTERVAL_MS,
} from "../components/analyticsBackend/BackendSyncAgent";
import configData from "../configData.json";

const SESSION_CHECK_INTERVAL = 60 * 1000; // Vérifier la durée de session toutes les minutes

function showSessionTimeoutMessage() {
  alert(
    "Votre session a atteint sa durée maximale de 2 heures et a été fermée."
  );
}

// Create session in backend immediately on login to get backendId
async function createSessionInBackend(session) {
  try {
    console.log(
      "🚀 [SessionTracker] Creating session in backend on login:",
      session.sessionId
    );

    const authToken = localStorage.getItem("token");
    if (!authToken) {
      console.error("❌ [SessionTracker] No auth token for session creation");
      return null;
    }

    const response = await fetch(
      `${configData.SERVER_URL}createSessionOrEvent`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": authToken,
        },
        body: JSON.stringify({
          createSession: true,
          session: {
            sessionId: session.sessionId,
            email: session.userId,
            startedAt: session.startedAt,
            endedAt: null,
            heartbeats: session.heartbeats || [],
            activity_duration: session.activity_duration || 0,
            inactivity_duration: session.inactivity_duration || 0,
            sessionDurationReached: session.sessionDurationReached || false,
          },
        }),
      }
    );

    if (!response.ok) {
      console.error(
        "❌ [SessionTracker] Failed to create session in backend:",
        response.status
      );
      return null;
    }

    const responseData = await response.json();
    const backendId = responseData?.session?._id;

    if (backendId) {
      console.log(
        "✅ [SessionTracker] Backend session created, backendId:",
        backendId
      );
      return backendId;
    } else {
      console.warn("⚠️ [SessionTracker] No backendId in response");
      return null;
    }
  } catch (error) {
    console.error("💥 [SessionTracker] Error creating backend session:", error);
    return null;
  }
}

export default function useSessionTracker(isLoggedIn, onSessionEnd) {
  const userEmail = useSelector((state) => state.user?.user?.email);
  const heartbeatTimer = useRef(null);
  const sessionCheckTimer = useRef(null);
  const autosaveTimer = useRef(null);
  const sessionExtended = useRef(false); // Pour tracker si on a déjà prolongé
  const lastActivity = useRef(Date.now()); // Pour détecter l'activité utilisateur
  const isTabActive = useRef(true); // Pour détecter si l'onglet est actif
  const prevIsLoggedIn = useRef(undefined);

  // Crée une session uniquement au login
  useEffect(() => {
    if (isLoggedIn && userEmail) {
      // Nettoyer les anciennes sessions orphelines
      fixOrphanedSessions();

      // Tenter de reprendre la session si un marqueur récent existe
      try {
        const markerRaw = sessionStorage.getItem("sessionResumeIntent");
        if (markerRaw) {
          const marker = JSON.parse(markerRaw);
          // fenêtre de reprise: 2 minutes
          if (
            marker &&
            marker.email === userEmail &&
            Date.now() - marker.ts < 2 * 60 * 1000
          ) {
            // Si pas de currentSession (par ex. backend a été fermé trop vite), ne pas créer une nouvelle
            const existing = getCurrentSession();
            if (!existing) {
              // Rien à faire: l'ancienne session a été archivée; on ne la ressuscite pas ici pour éviter les incohérences
              // On laisse la création standard faire son travail juste après
            }
            // Nettoyage du marqueur (one-shot)
            sessionStorage.removeItem("sessionResumeIntent");
          } else {
            sessionStorage.removeItem("sessionResumeIntent");
          }
        }
      } catch {}

      let session = getCurrentSession();
      if (!session || session.userId !== userEmail || session.endedAt) {
        // Créer une nouvelle session avec la nouvelle structure
        session = createNewSession(userEmail);
        saveCurrentSession(session);

        // Immediately create session in backend to get backendId
        createSessionInBackend(session)
          .then((backendId) => {
            if (backendId) {
              session.backendId = backendId;
              saveCurrentSession(session);
              console.log(
                "✅ [SessionTracker] Session initialized with backendId:",
                backendId
              );
            } else {
              console.warn(
                "⚠️ [SessionTracker] Session created without backendId (will create on first autosave)"
              );
            }
          })
          .catch((err) => {
            console.warn(
              "⚠️ [SessionTracker] Failed to create backend session on login:",
              err
            );
          });
      }

      // Démarrer les timers et listeners
      startHeartbeatTimer();
      startSessionChecker();
      startAutosaveTimer();
      setupActivityListeners();

      // Gestionnaire à l'unload: ne PAS clôturer la session pour conserver le même sessionId au rafraîchissement.
      // On pose un marqueur de reprise et on laisse fixOrphanedSessions/clôture par timeout faire leur travail si besoin.
      const handleBeforeUnload = () => {
        try {
          const current = getCurrentSession();
          if (current && !current.endedAt) {
            const marker = {
              sessionId: current.sessionId,
              email: current.userId,
              ts: Date.now(),
            };
            sessionStorage.setItem(
              "sessionResumeIntent",
              JSON.stringify(marker)
            );
          }
        } catch (e) {
          // noop
        }
      };
      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        clearInterval(heartbeatTimer.current);
        clearInterval(sessionCheckTimer.current);
        clearInterval(autosaveTimer.current);
        cleanupActivityListeners();
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
    // eslint-disable-next-line
  }, [isLoggedIn, userEmail]);

  // Ne plus gérer la déconnexion ici pour éviter les doubles appels.
  // La synchronisation de fin de session est orchestrée dans authActions.logout().
  useEffect(() => {
    prevIsLoggedIn.current = isLoggedIn;
    // eslint-disable-next-line
  }, [isLoggedIn]);

  // Timer pour envoyer des heartbeats toutes les 5 minutes
  function startHeartbeatTimer() {
    clearInterval(heartbeatTimer.current);
    heartbeatTimer.current = setInterval(() => {
      const session = getCurrentSession();
      if (session && !session.endedAt) {
        // Envoyer un heartbeat seulement si l'onglet est actif ET l'utilisateur a été actif récemment
        const timeSinceLastActivity = Date.now() - lastActivity.current;
        const isRecentlyActive = timeSinceLastActivity < 30 * 1000; // CORRECTION: 30 secondes seulement

        if (isTabActive.current && isRecentlyActive) {
          addHeartbeat();
          lastActivity.current = Date.now(); // Mise à jour après heartbeat réussi
          console.log("Heartbeat envoyé - utilisateur actif dans l'onglet");
        } else {
          console.log(
            "Heartbeat non envoyé - utilisateur inactif ou onglet inactif"
          );
        }
      }
    }, HEARTBEAT_INTERVAL);
  }

  // Timer pour vérifier la durée de session
  function startSessionChecker() {
    clearInterval(sessionCheckTimer.current);
    sessionCheckTimer.current = setInterval(() => {
      const result = checkSessionTimeout();

      if (result === "END_SESSION") {
        const session = endCurrentSession("max_duration_reached");
        if (session) {
          showSessionTimeoutMessage();
          if (typeof onSessionEnd === "function") {
            onSessionEnd();
          }
        }
      } else if (result === "EXTEND_SESSION") {
        // La session continue car l'utilisateur est actif après 1h
        console.log("Session prolongée car utilisateur encore actif après 1h");
      }
    }, SESSION_CHECK_INTERVAL);
  }

  // Timer for periodic autosave flushes
  function startAutosaveTimer() {
    clearInterval(autosaveTimer.current);
    autosaveTimer.current = setInterval(() => {
      const session = getCurrentSession();
      if (session && !session.endedAt) {
        autosaveCurrentSession("interval").catch((err) => {
          console.warn(
            "[SessionTracker] Autosave failed:",
            err?.message || err
          );
        });
      }
    }, AUTOSAVE_INTERVAL_MS);
  }

  // Terminer manuellement la session
  function endSession() {
    const session = endCurrentSession("manual");
    if (session && typeof onSessionEnd === "function") {
      onSessionEnd();
    }
  }

  // Gestionnaire d'activité utilisateur
  function activityHandler(event) {
    lastActivity.current = Date.now();
    // console.log('[SessionTracker] Activity detected:', event ? event.type : 'unknown');
  }

  // Gestion de la visibilité de l'onglet
  function handleVisibilityChange() {
    isTabActive.current = !document.hidden;
    if (!document.hidden) {
      // CORRECTION: Ne pas mettre à jour lastActivity automatiquement
      // lastActivity.current = Date.now(); // ← SUPPRIMÉ
      console.log(
        "[SessionTracker] Onglet redevenu actif - en attente d'interaction utilisateur"
      );
    } else {
      console.log("[SessionTracker] Onglet devenu inactif");
    }
  }

  function setupActivityListeners() {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    // Ajout listeners d'activité
    events.forEach((event) => {
      window.addEventListener(event, activityHandler, true);
      if (event === "click" || event === "scroll") {
        document.addEventListener(event, activityHandler, true);
      }
    });

    // Listener pour la visibilité de l'onglet
    document.addEventListener("visibilitychange", handleVisibilityChange);
  }

  function cleanupActivityListeners() {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    events.forEach((event) => {
      window.removeEventListener(event, activityHandler, true);
      if (event === "click" || event === "scroll") {
        document.removeEventListener(event, activityHandler, true);
      }
    });

    document.removeEventListener("visibilitychange", handleVisibilityChange);
  }
  return { endSession };
}
